import api from './api';
import { PainelOperacionalResponse, PeriodoPainel } from '../types/operacoes';

export const operacoesService = {
  getPainel: async (periodo: PeriodoPainel = 'hoje'): Promise<PainelOperacionalResponse> => {
    const { data } = await api.get('/operacoes/painel', { params: { periodo } });
    return data;
  }
};
